import React, {useState} from 'react';
import {deletePassMaster, savePassMaster, usePassMasterData} from "./usePassMaster";
import TablePage from "../../../pages/tablePage/TablePage";
import IsLoading from "../../../shared/components/IsLoading";
import ErrorPage from "../../../shared/components/ErrorPage";
import {REFRESH_TYPE_FUNCTION} from "../../../shared/utils/enum";
import {PassMasterEntity} from "./PassMasterEntity";
import {Switch} from "antd";
import dayjs from "dayjs";
import GameManagerEditModal from "../GameManagerEditModal";
import toast from "react-hot-toast";
import {useReloadTime} from "../../serverInfo/useServerInfo";

const PassManager = ({ passType }) => {
    const [rowData, setRowData] = useState({});
    const {data: passData, isLoading, error, refetch} = usePassMasterData(passType);
    const {data: reloadTimeData, isLoading: isReloadTimeData, error: reloadTimeDataError, refetch: reloadTimeDataRefetch} = useReloadTime();

    // On/Off 스위치 토글 핸들러
    const handleSwitchChange = async (checked, record) => {
        try {
            if (record.end < dayjs().unix() && record.onOff !== 1) {
                toast.error('종료된 시즌 패스는 On/Off 상태를 변경할 수 없습니다.');
                return;
            }

            record.onOff = checked ? 1 : 0;
            await savePassMaster(record);
            await refetch();
        } catch (e) {
            toast.error('On/Off 변경 실패');
        }
    };

    const columns = [
        {
            title: '시퀀스',
            dataIndex: 'seq',
            key: 'seq',
            width: 80,
        },
        {
            title: '패스 인덱스',
            dataIndex: 'index',
            key: 'index',
            width: 100,
        },
        {
            title: '패스 이름',
            dataIndex: 'name',
            key: 'name',
            width: 200,
        },
        {
            title: 'On/Off',
            dataIndex: 'onOff',
            render: (_, record) => (
                <Switch
                    checked={record.onOff === 1}
                    checkedChildren="On"
                    unCheckedChildren="Off"
                    onChange={checked => handleSwitchChange(checked, record)}
                    onClick={(_, e) => e.stopPropagation()}
                />
            ),
            filters: [
                {
                    text: 'On',
                    value: 1,
                },
                {
                    text: 'Off',
                    value: 0,
                },
            ],
        },
        {
            title: '시작 시간',
            dataIndex: 'begin',
            key: 'begin',
            width: 200,
            render: (_, {begin}) => {
                return dayjs.unix(begin).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        {
            title: '종료 시간',
            dataIndex: 'end',
            key: 'end',
            width: 200,
            render: (_, {end}) => {
                return dayjs.unix(end).format('YYYY-MM-DD HH:mm:ss');
            }
        }
    ];

    if (isLoading || isReloadTimeData) return <IsLoading/>;
    if (error || reloadTimeDataError) return <ErrorPage error={error}/>;

    const props = {
        columns,
        rowData,
        setRowData,
        isLoading: isLoading,
        localData: passData || [],
        entityModel: PassMasterEntity,
        modal: (modalProps) => <GameManagerEditModal {...modalProps} handleClose={() => { modalProps.handleClose(); refetch(); }} />,
        modalOptions: {
            save: savePassMaster,
            delete: deletePassMaster,
            entity: PassMasterEntity
        },
        refreshTypeFunc: REFRESH_TYPE_FUNCTION.GAME_DATA,
        reloadTime: reloadTimeData?.game_data_sync_id,
        reloadTimeRefetch: reloadTimeDataRefetch
    }

    return (
        <TablePage
            {...props}
        />
    );
};

export default PassManager;